import API from "./../../utils/GlobalAPI";

export async function getProjects() {
  try {
    const data = await API.getMethod(`projects`);
    console.log(data);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getProjectsByUserId(userId: string) {
  try {
    const data = await API.getMethod(`projects?_where[0][user.id]=${userId}`);
    console.log(data);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getProjectById(projectId: string) {
  try {
    const data = await API.getMethod(`projects/${projectId}`);
    console.log(data);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function postProject(projectdata: any) {
  try {
    const data = await API.postMethod("projects", projectdata);
    console.log(data);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function editProject(id: any, projectdata: any) {
  try {
    const data = await API.putMethod(`projects/${id}`, projectdata);
    console.log(data);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function deleteProject(projectId: any) {
  try {
    const data = await API.deleteMethod(`projects/${projectId}`);
    console.log(data);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getOtherProjects(projectId: string) {
  try {
    const data: any = await API.getMethod(`projects?_limit=6`);

    let realData = data.filter((project: any) => {
      return project.id !== projectId;
    });

    console.log(data);
    return realData;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function countProjectsByUserId(userId: string) {
  try {
    const data = await API.getMethod(
      `projects/count?_where[0][user.id]=${userId}`
    );
    return data;
  } catch (error) {
    return null;
  }
}
